import React, { Component } from "react"
import FormTextWrapper from "./FormTextWrapper"

export default class KeyInputConfiguration extends Component {
	propTypes: {
		formFields: React.PropTypes.array.isRequired,
	}

	handleChange = e => {
		this.setState({ value: e.target.value })
	}

	getData() {
		const formData = {}
		for (const ref in this.refs) {
			formData[ref] = this.refs[ref].getData()
		}
		return formData
	}

	render() {
		const { formFields } = this.props
		return (
			<div>
				{formFields.map(formField =>
					<FormTextWrapper key={formField["id"]} {...formField} />
				)}
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/forms/KeyInputConfiguration.js